<template>
  <label class="relative" :class="containerClass">
    <file-pond
      v-bind="attrs"
      ref="pond"
      :accepted-file-types="accept"
      :allow-multiple="multiple"
      :files="files"
      @addfile="addFile"
    />

    <slot />
  </label>

  <template v-if="showFiles && files?.length && !isUploading">
    <q-list class="w-full space-y-8 mt-8">
      <OFile
        v-for="(file, index) in files"
        :key="index"
        :file="file"
        @click:remove-file="removeFile"
      />
    </q-list>
  </template>
</template>

<script setup>
import { ref, useAttrs } from 'vue'
import vueFilePond from 'vue-filepond'

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

import 'filepond/dist/filepond.min.css'

import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import OFile from 'components/FileUploader/OFile.vue'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

const attrs = useAttrs()

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false,
  },
  showFiles: {
    type: Boolean,
    default: true,
  },
  accept: {
    type: String,
    default: 'image/jpeg, image/png',
  },
  containerClass: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['change'])

const pond = ref(null)
const files = ref([])
const isUploading = ref(false)

function addFile(error, { file }) {
  isUploading.value = true

  try {
    if (error) {
      console.error(error)
      // throw new Error(error)
    }

    if (!props.multiple && files.value?.length === 1) {
      files.value.pop()
    }

    const fileObject = {
      name: URL.createObjectURL(file),
      file,
    }

    files.value.push(fileObject)

    emits('change', files.value)
  } catch (error) {
    console.error(error)
  } finally {
    isUploading.value = false
  }
}

function removeFile(fileName) {
  console.log({ fileName })

  files.value = files.value.filter((file) => file.name !== fileName)

  emits('change', files.value)
}
</script>

<style lang="sass">
.filepond
  &--credits
    display: none

  &--drop-label
    display: none

  &--wrapper
    position: absolute
    top: 0
    width: 100%
    height: 174px
    opacity: 0

  &--root
    height: 174px

  &--list-scroller
    display: none
</style>
